import { Button, IconButton } from '@pay-com/components'
import { Close, Edit } from '@pay-com/icons'

type IndividualRoleCardProps = {
  title: string
  description: string
  addLabel: string
  roleLabel?: string
  data: {
    individual: {
      firstName?: string | null
      lastName?: string | null
      email?: string | null
    }
    relation: { title?: string | null } | undefined
  } | null
  onAdd?: () => void
  onEdit: () => void
  onRemove?: () => void
}

export const IndividualRoleCard = ({
  title,
  description,
  addLabel,
  roleLabel,
  data,
  onAdd,
  onEdit,
  onRemove
}: IndividualRoleCardProps) => {
  if (data) {
    return (
      <div className="flex items-center justify-between rounded-lg bg-gray-50 p-3 md:p-6">
        <div className="flex flex-col">
          <span className="text-sm font-medium">
            {[data.individual.firstName, data.individual.lastName]
              .filter(Boolean)
              .join(' ')}
          </span>
          <span className="text-xs text-gray-500">
            {[data.individual.email, roleLabel ?? data.relation?.title]
              .filter(Boolean)
              .join(' | ')}
          </span>
        </div>
        <div className="flex gap-2">
          <IconButton
            variant="secondary"
            type="button"
            title="edit"
            onClick={onEdit}
          >
            <Edit color="primary" width={20} />
          </IconButton>
          {onRemove && (
            <IconButton
              variant="secondary"
              type="button"
              title="remove"
              onClick={onRemove}
            >
              <Close color="primary" width={20} />
            </IconButton>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-between rounded-lg bg-gray-50 p-3 md:p-6">
      <div className="flex flex-col">
        <span className="text-sm font-medium">{title}</span>
        <span className="text-xs text-gray-500">{description}</span>
      </div>
      {onAdd && (
        <Button
          type="button"
          variant="secondary"
          className="whitespace-nowrap"
          onClick={onAdd}
        >
          + {addLabel}
        </Button>
      )}
    </div>
  )
}
